import { PaymentHandler, PayResult } from '@/store/models';

export default class CashOnDelivery implements PaymentHandler {
    public init() {
        return new Promise((resolve, reject) => {
            resolve({});
        });
    }
    public pay(amount: number): Promise<PayResult> {
        return new Promise((resolve, reject) => {
            resolve({needsFinalization: true});
        });
    }
    public teardown() {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
}
